import { __assign } from "tslib";
import { formatDollars } from '../../../../utils/formatting';
var premiumContentAdapter = function (props) {
    var _a, _b, _c;
    var deviation = props.deviation;
    var price = (_b = (_a = deviation.pcp) === null || _a === void 0 ? void 0 : _a.downloadPrice) !== null && _b !== void 0 ? _b : '???';
    var dollarsCost = ((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.downloadDollarPrice) !== undefined
        ? formatDollars(deviation.pcp.downloadDollarPrice)
        : '???';
    return __assign(__assign({}, props), { price: price, dollarsCost: dollarsCost, priceLabel: 'shop.thumb.points' });
};
export default premiumContentAdapter;
//# sourceMappingURL=premiumContent.js.map